<template>
  <b-nav align="center" class=" d-block text-center d-md-flex">
    <a
      class="m-50 m-md-0"
      v-for="(item, index) in MenuItems"
      :key="index"
      :data="item.name"
      :href="item.href"
      :target="item.new_tab === 1 ? '_blank' : ''"
    >
      {{ item.name }}
    </a>
    <b-link
      to="/admin/report">
      Дилерам
    </b-link>
  </b-nav>
</template>

<script>
import { BNav, BLink } from 'bootstrap-vue'

export default {
  name: 'Menu',
  components: {
    BNav,
    BLink,
  },
  data: () => ({
    MenuItems: [],
    url: '',
  }),
  methods: {
    readItemsMenu() {
      const that = this
      that.$http.get(`${this.url}/api/menus`, {}, {})
        .then(response => {
          that.MenuItems = response.data
        }).catch()
    },
  },
  created() {
    // const url = window.location.href
    // const arr = url.split('//')
    // const domain = arr[1].split(':')
    this.url = 'https://tojtel.tj'
    this.readItemsMenu()
  },
}
</script>

<style scoped>
.nav a {
  text-transform: uppercase;
  font-weight: 500;
  display: inline-block;
  margin: 0 10px !important;
}
</style>
